import React from "react";
import { connect } from "react-redux";
import {
    getPODetails,
    getPOLineItems,
    getPOLineItem,
} from "../Actions/POViewAPI";
import {
    Button,
    Popover,
    PopoverHeader,
    PopoverBody,
    UncontrolledPopover,
} from "reactstrap";
import Moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import {
    DownloadDocument,
    deleteMDocument,
    deleteSDocument,
    DeleteMDocSdocAttachments,
} from "../Actions/CommonAPI";
import { toast, ToastContainer } from "react-toastify";

let user = JSON.parse(localStorage.getItem("currentUser"));

class POViewHMV extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isChecked: false,
            IHMYes: false,
            IHMNo: false,
            showEditPo: this.props.match?.params?.type ?? "",
            // keywords: "",
            PoConfirmation: {
                shipId: 0,
                purchaseOrderId: 0,
                poLineItemId: 0,
                ihmPresence: false,
                collectMdocSdoc: false,
                notApplicable: false,
                addKeyWords: false,
                isConfirmed: true,
                keyword: "",
                modifiedBy: "",
            },
            LineItem: [],
            options: [
                {
                    id: 1,
                    name: "yes",
                    value: "Yes",
                },
                {
                    id: 2,
                    name: "no",
                    value: "No",
                },
                {
                    id: 3,
                    name: "na",
                    value: "NA",
                },
                {
                    id: 4,
                    name: "collect",
                    value: "Collect MDoc & SDoC",
                },
            ],
            EditAll: false,
            taskType: "poconfirmation",
        };
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkBoxClick = this.checkBoxClick.bind(this);
        this.ConfirmPO = this.ConfirmPO.bind(this);
    }

    componentDidMount() {
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipid, poid, type } = params;
        dispatch({ type: "noPoLineItems", data: false });
        dispatch({ type: "SubBannerTitle", data: "PO Validation" });
        if (shipid !== "" && poid !== "" && type) {
            // dispatch(getPODetails(poid));
            let url = `${API.PODetail}?poId=${poid}`;
            axios
                .get(url)
                .then((response) => {
                    history.location.pathname ==
                        `/Home/POViewRead/${shipid}/${poid}/${type}`
                        ? dispatch(getPOLineItems(poid, type))
                        : dispatch(getPOLineItem(poid));
                    dispatch({
                        type: "getPODetailsSuccess",
                        data: response.data,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: "getPODetailsFailure",
                        error: "ERROR",
                    });
                });
        } else if (shipid !== "" && poid !== "") {
            // dispatch(getPODetails(poid));
            // debugger
            let url = `${API.PODetail}?poId=${poid}`;
            axios
                .get(url)
                .then((response) => {
                    history.location.pathname == `/Home/POViewEdit/${shipid}/${poid}`
                        ? dispatch(getPOLineItems(poid, this.state.taskType))
                        : dispatch(getPOLineItem(poid));
                    dispatch({
                        type: "getPODetailsSuccess",
                        data: response.data,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: "getPODetailsFailure",
                        error: "ERROR",
                    });
                });
        }
        // if (history.location.pathname == `/Home/POViewEdit/${shipid}/${poid}`) {
        //     this.props.dispatch({ type: "EditPOView", data: true });

        // }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { POLineItems, dispatch, noPoLineItems } = nextProps;
        if (noPoLineItems == true) {
            prevState.isLoaded = noPoLineItems;
        } else {
            prevState.isLoaded = false;
        }
        if (POLineItems && prevState.LineItem && prevState.LineItem.length === 0) {
            prevState.LineItem =
                POLineItems &&
                POLineItems.map((d, i) => {
                    let obj = {
                        comments: d.comments,
                        createdBy: d.createdBy,
                        createdDate: d.createdDate,
                        currentStatus: d.currentStatus,
                        itemDescription: d.itemDescription,
                        mdocAttachmentGuid: d.mdocAttachmentGuid,
                        mdocAttachmentId: d.mdocAttachmentId,
                        mdocAttachmentName: d.mdocAttachmentName,
                        modifiedBy: user.email,
                        modifiedDate: d.modifiedDate,
                        partNo: d.partNo,
                        poLineItemId: d.poLineItemId,
                        purchaseOrderId: d.purchaseOrderId,
                        quantity: d.quantity,
                        sdocAttachmentGuid: d.sdocAttachmentGuid,
                        sdocAttachmentId: d.sdocAttachmentId,
                        sdocAttachmentName: d.sdocAttachmentName,
                        shipId: d.shipId,
                        units: d.units,
                        ihmPresence: false,
                        collectMdocSdoc: d.ihmPresence,
                        notApplicable: false,
                        isConfirmed: false,
                        isPchm: false,
                        keyword: "",
                        radioButton: (d.ihmPresence && d.sdocAttachmentGuid && d.mdocAttachmentGuid) ? "Yes" : (d.ihmPresence && !(d.sdocAttachmentGuid && d.mdocAttachmentGuid)) ? "CL" : "No",
                        make: d.make,
                        model: d.model
                    };
                    return obj;
                });
        }
        dispatch({ type: "getPOLineItemsSuccess", data: null });
    }

    handleCommonRadioButtonChange(value) {
        var lineitems = this.state.LineItem;
        lineitems &&
            lineitems.map((a, i) => {
                if (value === "Yes") {
                    a.radioButton = value;
                    a.ihmPresence = true;
                    a.collectMdocSdoc = false;
                    a.notApplicable = false;
                }
                if (value === "No") {
                    if (a?.itemDescription === "" || a?.itemDescription === null) {
                        a.radioButton = "NA";
                        a.ihmPresence = false;
                        a.collectMdocSdoc = false;
                        a.notApplicable = false;
                    } else {
                        a.radioButton = value;
                        a.ihmPresence = false;
                        a.collectMdocSdoc = false;
                        a.notApplicable = false;
                    }
                }
            });
        this.setState({ LineItem: lineitems });
    }

    handleRadioButtonChange(e, value, id) {
        var lineitems = this.state.LineItem;
        lineitems &&
            lineitems.map((a, i) => {
                console.log(id, a.poLineItemId);
                if (a.poLineItemId === id && value === "Yes") {
                    a.radioButton = value;
                    a.ihmPresence = true;
                    a.collectMdocSdoc = false;
                    a.notApplicable = false;
                }
                if (a.poLineItemId === id && value === "No") {
                    a.radioButton = value;
                    a.ihmPresence = false;
                    a.collectMdocSdoc = false;
                    a.notApplicable = false;
                }
                if (a.poLineItemId === id && value === "NA") {
                    a.radioButton = value;
                    a.notApplicable = true;
                    a.ihmPresence = false;
                    a.collectMdocSdoc = false;
                }
                if (a.poLineItemId === id && value === "CL") {
                    a.radioButton = value;
                    a.collectMdocSdoc = true;
                    a.ihmPresence = false;
                    a.notApplicable = false;
                }
            });
        this.setState({ LineItem: lineitems });

        // lineitems && lineitems.map((a, i) => {
        //     let nodeName = e.target.name;
        //     if (nodeName === "IHMYes") {
        //         a.ihmPresence = true;
        //         a.collectMdocSdoc = false;
        //         a.notApplicable = false;
        //     } else if (nodeName === "IHMNo") {
        //         a.notApplicable = false;
        //         a.collectMdocSdoc = false;
        //         a.ihmPresence = false;
        //     }
        //     else if (nodeName === "notApplicable") {
        //         a.notApplicable = true;
        //         a.collectMdocSdoc = false;
        //         a.ihmPresence = false;
        //     } else if (nodeName === "collectMdocSdoc") {
        //         a.notApplicable = false;
        //         a.collectMdocSdoc = true;
        //         a.ihmPresence = false;
        //     }
        // });
    }

    handleInputChange(e, i) {
        // this.state.keywords=e.target.value;
        this.state.LineItem[i].keyword = e.target.value;
        this.setState({});
    }

    checkBoxClick(e) {
        let checked = this.state.isChecked;
        if (e.target.checked) {
            checked = true;
        } else {
            checked = false;
        }
        this.state.PoConfirmation.addKeyWords = checked;
        this.setState({});
    }

    ConfirmPO(item) {
        const { dispatch, match } = this.props;
        if (item.ihmPresence === true) {
            this.state.PoConfirmation.ihmPresence = true;
        } else if (item.ihmPresence === false) {
            this.state.PoConfirmation.ihmPresence = false;
        }
        confirmAlert({
            message: "Are you sure want to confirm?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        this.state.PoConfirmation.shipId = item.shipId;
                        this.state.PoConfirmation.purchaseOrderId = item.purchaseOrderId;
                        this.state.PoConfirmation.poLineItemId = item.poLineItemId;
                        let url = `${API.PoConfirmation}`;
                        axios
                            .put(url, this.state.PoConfirmation)
                            .then((response) => {
                                dispatch(
                                    getPOLineItems(match.params.poid, this.state.taskType)
                                );
                                toast.success("Po confirmed successfully.", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                dispatch({
                                    type: "POConfirmationSuccess",
                                    data: response.data,
                                });
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "POConfirmationFailure",
                                    error: "ERROR",
                                });
                            });

                        //  dispatch(UpdatePOConfirmation(this.state.PoConfirmation));
                    },
                },
                {
                    label: "No",
                    onClick: () => { },
                },
            ],
        });
    }

    toggle = (target, item) => {
        this.state.PoConfirmation.ihmPresence = false;
        this.state.PoConfirmation.collectMdocSdoc =
            !item.mdocAttachmentName || !item.sdocAttachmentName ? true : false;
        this.state.PoConfirmation.notApplicable = false;
        this.state.PoConfirmation.addKeyWords = false;
        this.state.PoConfirmation.isConfirmed = false;
        this.state.PoConfirmation.keyword = "";
        this.setState({
            [target]: !this.state[target],
            IHMYes: false,
            IHMNo: false,
            isChecked: false,
            keywords: "",
        });
    };
    confirmAll = (item) => {
        const { dispatch, match, POLineItems } = this.props;
        const { params } = match;
        const { shipid, poid } = params;
        // let POitems = {
        //     shipId: item.shipId,
        //     purchaseOrderId: item.purchaseOrderId,
        // poLineItemId: 0,
        //     ihmPresence: item.ihmPresence ? true : false,
        //     collectMdocSdoc: false,
        //     isConfirmed: true,
        //     notApplicable: false,
        //     addKeyWords: false,
        //     keyword: "",
        //     modifiedBy: ""
        // }

        confirmAlert({
            message: "Are you sure want to confirm?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        let url = `${API.PCHM}`;
                        axios
                            .put(url, this.state.LineItem)
                            .then((response) => {
                                // dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                toast.success("Po confirmed successfully.", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                this.setState({ LineItem: POLineItems });
                                dispatch(getPOLineItems(poid, this.state.taskType));
                                dispatch({
                                    type: "POConfirmationSuccess",
                                    data: response.data,
                                });
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "POConfirmationFailure",
                                    error: "ERROR",
                                });
                            });
                    },
                },
                {
                    label: "No",
                    onClick: () => { },
                },
            ],
        });
    };

    deleteMDOcSDocAttachments = () => {
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipid, poid, type } = params;
        confirmAlert({
            message: 'Are you sure want to delete "All MD and SDoC" ?',
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        if (type === undefined) {
                            history.location.pathname == `/Home/POViewEdit/${shipid}/${poid}`
                                ? dispatch(DeleteMDocSdocAttachments(poid, this.state.taskType))
                                : dispatch(DeleteMDocSdocAttachments(poid));
                        } else {
                            dispatch(DeleteMDocSdocAttachments(poid, type));
                        }

                        this.state.LineItem = [];
                    },
                },
                {
                    label: "No",
                    onClick: () => { },
                },
            ],
        });
    };

    submitAll = (item) => {
        const { dispatch, match, POLineItems } = this.props;
        const { PoConfirmation, IHMYes, IHMNo } = this.state;

        let POitems = {
            shipId: item.shipId,
            purchaseOrderId: item.purchaseOrderId,
            // poLineItemId: 0,
            ihmPresence: this.state.PoConfirmation.ihmPresence,
            collectMdocSdoc: this.state.PoConfirmation.collectMdocSdoc,
            notApplicable: this.state.PoConfirmation.notApplicable,
            addKeyWords: this.state.PoConfirmation.addKeyWords,
            keyword: this.state.PoConfirmation.keyword,
            isConfirmed: false,
            modifiedBy: this.state.PoConfirmation.modifiedBy,
        };

        this.setState({
            EditAll: !this.state.EditAll,
        });

        // let lineItems = POLineItems.filter(r => { return r.sdocAttachmentName === null || r.mdocAttachmentName === null })

        // if (PoConfirmation.ihmPresence && lineItems.length > 0) {
        //     swal('Error!', "Some of the line items don't have Mdoc and Sdoc. Please collect Mdoc and Sdoc to proceed!", 'warning');
        // }
        // else {
        if (
            PoConfirmation.collectMdocSdoc ||
            PoConfirmation.notApplicable ||
            IHMYes ||
            IHMNo
        ) {
            confirmAlert({
                message: "Are you sure want to update?",
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => {
                            let url = `${API.PoConfirmationAll}`;
                            axios
                                .put(url, POitems)
                                .then((response) => {
                                    dispatch(
                                        getPOLineItems(match.params.poid, this.state.taskType)
                                    );
                                    toast.success("Po updated successfully.", {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                                    dispatch({
                                        type: "POConfirmationSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "POConfirmationFailure",
                                        error: "ERROR",
                                    });
                                });
                        },
                    },
                    {
                        label: "No",
                        onClick: () => { },
                    },
                ],
            });
        } else {
            swal("Error!", "Please select the option", "warning");
        }
        // }
    };
    togglePopover = () => {
        this.state.PoConfirmation.ihmPresence = false;
        this.state.PoConfirmation.notApplicable = false;
        this.state.PoConfirmation.addKeyWords = false;
        this.state.PoConfirmation.collectMdocSdoc = false;
        this.state.PoConfirmation.isConfirmed = false;
        this.state.PoConfirmation.keyword = "";
        this.setState({
            EditAll: !this.state.EditAll,
            IHMYes: false,
            IHMNo: false,
            isChecked: false,
            keywords: "",
        });
    };
    togglesubmit = (target, item) => {
        const { dispatch, match } = this.props;
        const { PoConfirmation, IHMYes, IHMNo } = this.state;
        this.setState({
            [target]: !this.state[target],
        });
        if (
            PoConfirmation.collectMdocSdoc ||
            PoConfirmation.notApplicable ||
            IHMYes ||
            IHMNo
        ) {
            confirmAlert({
                message: "Are you sure want to update?",
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => {
                            this.state.PoConfirmation.shipId = item.shipId;
                            this.state.PoConfirmation.purchaseOrderId = item.purchaseOrderId;
                            this.state.PoConfirmation.poLineItemId = item.poLineItemId;
                            let url = `${API.PoConfirmation}`;
                            axios
                                .put(url, PoConfirmation)
                                .then((response) => {
                                    dispatch(
                                        getPOLineItems(match.params.poid, this.state.taskType)
                                    );
                                    toast.success("Po updated successfully.", {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                                    dispatch({
                                        type: "POConfirmationSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "POConfirmationFailure",
                                        error: "ERROR",
                                    });
                                });
                        },
                    },
                    {
                        label: "No",
                        onClick: () => { },
                    },
                ],
            });
        } else {
            swal("Error!", "Please select the option", "warning");
        }
    };

    hideSidePanel = () => {
        this.props.history.goBack();
    };

    render() {
        const { PODetail, editPOView, POLineItems } = this.props;
        const { LineItem, showEditPo } = this.state;
        console.log("podelete", this.state.showEditPo);
        let MDocSDoc =
            LineItem &&
            LineItem.filter(
                (r) => r.mdocAttachmentName !== null || r.sdocAttachmentName !== null
            );
        console.log("mdocsdoc", MDocSDoc);
        console.log("line", this.state.LineItem);
        console.log("lineProps", this.props);
        return (
            <div className="full-height px-4 pb-4">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                </button>
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="panel-box">
                            <div
                                className="card MM-card-header mb-0"
                                style={{ backgroundColor: "white" }}
                            >
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <h5
                                                className="card-title ml-2 my-2"
                                                style={{ color: "092a51" }}
                                            >
                                                {PODetail ? PODetail.poNo : ""}
                                            </h5>
                                        </div>
                                        <div className="col-sm-3">
                                            <h5
                                                className="card-title ml-2 my-2"
                                                style={{ color: "092a51" }}
                                            >
                                                {PODetail ? PODetail.prNo : ""}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-md-12 ">
                                            <div className="row">
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>PO Date : </strong>
                                                        <span className="italicFont">
                                                            {PODetail
                                                                ? Moment(
                                                                    new Date(Date.parse(PODetail.poDate))
                                                                ).format("DD MMM YYYY")
                                                                : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Make : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {PODetail ? PODetail.make : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Model : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {PODetail ? PODetail.model : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>IHM Presense : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        {editPOView ? (
                                                            <>
                                                                <input
                                                                    className="ml-1"
                                                                    type="radio"
                                                                    name={"IHMPresense"}
                                                                    id={"IHMYes"}
                                                                    onChange={() =>
                                                                        this.handleCommonRadioButtonChange("Yes")
                                                                    }
                                                                />
                                                                <span className="ml-1">Yes</span>
                                                                <input
                                                                    className="ml-1"
                                                                    type="radio"
                                                                    name={"IHMPresense"}
                                                                    id={"IHMNo"}
                                                                    onChange={() =>
                                                                        this.handleCommonRadioButtonChange("No")
                                                                    }
                                                                />
                                                                <span className="ml-1">No</span>
                                                            </>
                                                        ) : (
                                                            <span className="italicFont mr-3">
                                                                {PODetail?.isPCHM
                                                                    ? "PCHM"
                                                                    : PODetail?.ihmPresence
                                                                        ? "Yes"
                                                                        : "No"}
                                                            </span>
                                                        )}
                                                        {editPOView ? (
                                                            <div class="btn-group" style={{ color: "#fff" }}>
                                                                {/* <button class="btn btn-secondary btn-xs btn-conf-edit" data-confirmation="cancel" style={{ width: "85px" }} id='EditAll' disabled={POLineItems && POLineItems.length ? false : true}>
                                                                    <i class="glyphicon glyphicon-remove"></i> Edit All
                                                                </button>
                                                                <Popover placement="auto" trigger="legacy"
                                                                    isOpen={this.state.EditAll}
                                                                    target='EditAll'
                                                                    toggle={() => this.togglePopover()}>
                                                                    <PopoverHeader>Edit</PopoverHeader>
                                                                    <PopoverBody>
                                                                        <span><strong>IHM Presense</strong></span><br></br>
                                                                        <div className="row">
                                                                            <div className="col-4 my-1">
                                                                                <input type="radio" name="IHMYes" checked={this.state.IHMYes} onChange={e => this.handleRadioButtonChange(e)} />
                                                                                <span className="ml-1">Yes</span>
                                                                            </div>
                                                                            <div className="col-4 my-1">
                                                                                <input type="radio" name="IHMNo" checked={this.state.IHMNo} onChange={e => this.handleRadioButtonChange(e)} />
                                                                                <span className="ml-1">No</span>
                                                                            </div>
                                                                            <div className="col-4 my-1">
                                                                                <input type="radio" name="notApplicable" checked={this.state.PoConfirmation.notApplicable} onChange={e => this.handleRadioButtonChange(e)} />
                                                                                <span className="ml-1">NA</span>
                                                                            </div>
                                                                            <div className="col-12 my-1">
                                                                                <input type="radio" name="collectMdocSdoc" checked={this.state.PoConfirmation.collectMdocSdoc} onChange={e => this.handleRadioButtonChange(e)} />
                                                                                <span className="ml-1">Collect MD & SDoc</span>
                                                                            </div>
                                                                            <div className="col-12 my-1">
                                                                                <input type="checkbox" name="addKeyWords" checked={this.state.PoConfirmation.addKeyWords} onChange={e => this.checkBoxClick(e)} />
                                                                                <span className="ml-1"><strong>Add keywords</strong></span>
                                                                            </div>
                                                                            {this.state.PoConfirmation.addKeyWords ?
                                                                                <div className="col-12 my-1">
                                                                                    <input type="text" name="keywords" value={this.state.keywords} className="form-control" style={{ height: "33px" }} onChange={e => this.handleInputChange(e)}></input>
                                                                                </div>
                                                                                : null}
                                                                            <div className="col-12 mt-1" style={{ textAlign: "right" }}>
                                                                                <div className="btn-group">
                                                                                    <Button className="btn btn-primary btn-xs" size="sm" onClick={() => this.submitAll(PODetail)}>Submit</Button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </PopoverBody>
                                                                </Popover> */}
                                                                {showEditPo !== "Read" &&
                                                                    showEditPo !== "shippendingtask" && (
                                                                        <button
                                                                            class="btn btn-success btn-xs btn-conf-edit"
                                                                            data-confirmation="confirm"
                                                                            style={{ width: "83px" }}
                                                                            onClick={() => this.confirmAll(PODetail)}
                                                                        >
                                                                            <i class="glyphicon glyphicon-ok"></i>{" "}
                                                                            Confirm All
                                                                        </button>
                                                                    )}
                                                                {showEditPo !== "Read" &&
                                                                    showEditPo !== "shippendingtask" && (
                                                                        <div className="m-auto">
                                                                            <button
                                                                                class="btn btn-secondary btn-xs btn-conf-edit ml-1"
                                                                                data-confirmation="confirm"
                                                                                style={{ width: "157px" }}
                                                                                onClick={() =>
                                                                                    this.ShowMaterialDeclaration("")
                                                                                }
                                                                            >
                                                                                <i class="glyphicon glyphicon-ok"></i>{" "}
                                                                                Upload MD & SDoC
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        ) : null}
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Supplier Name : </strong>
                                                        <span className="italicFont ">
                                                            {PODetail ? PODetail.supplierName : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div
                                                    className="col-md-3 py-1"
                                                    style={{ wordBreak: "break-all" }}
                                                >
                                                    <span>
                                                        <strong>Supplier Email : </strong>
                                                        <span className="italicFont ">
                                                            {PODetail ? PODetail.supplierEmail : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>PO Description : </strong>
                                                        <span className="italicFont ">
                                                            {PODetail ? PODetail.poDescription : ""}
                                                        </span>
                                                    </span>
                                                </div>
                                                {showEditPo !== "Read" &&
                                                    showEditPo !== "shippendingtask" && (
                                                        <div className="col-md-3 py-1">
                                                            <button
                                                                disabled={
                                                                    (MDocSDoc && MDocSDoc.length === 0) ||
                                                                    MDocSDoc === null
                                                                }
                                                                class="btn btn-danger btn-xs btn-conf-edit"
                                                                data-confirmation="confirm"
                                                                style={{ width: "200px" }}
                                                                onClick={() => this.deleteMDOcSDocAttachments()}
                                                            >
                                                                <i class="glyphicon glyphicon-ok"></i> Delete
                                                                All MD and SDoC
                                                            </button>
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div
                            className="card MM-card-header"
                            style={{ backgroundColor: "white" }}
                        >
                            <div className="card-body">
                                <h5
                                    className="card-title ml-2 mt-2"
                                    style={{ color: "092a51" }}
                                >
                                    Line Items
                                </h5>
                            </div>
                        </div>
                        <div className="p-0">
                            <div className="row">
                                <div className="col-md-12">{this.renderLineItemCard()}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLineItemCard() {
        const { editPOView, POLineItems } = this.props;
        const { LineItem, options } = this.state;
        console.log("item", LineItem);
        return LineItem && LineItem.length ? (
            LineItem.map((item, index) => {
                console.log(item);
                console.log("radio", item.radioButton);
                return (
                    <>
                        <div
                            className="card"
                            style={{
                                overflow: "hidden",
                                position: "relative",
                                marginBottom: "5px",
                            }}
                            key={index}
                        >
                            {/* <div className="arrow-left-red"></div> */}
                            {item.ihmPresence == "Yes" ||
                                item.ihmPresence ||
                                item.collectMdocSdoc ? (
                                <div className="arrow-left-red"></div>
                            ) : (
                                <div className="arrow-left-green"></div>
                            )}
                            <div className="px-4 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>Serial No : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.poLineItemId}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>Qty : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">{item.quantity}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>Unit : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">{item.units}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Part No/Drawing No : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">{item.partNo}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>Current Status: </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont mr-3">
                                                            {item.currentStatus}
                                                        </span>
                                                    </span>
                                                    {/* <span>
                                                        <strong>IHM Presense : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont mr-3">
                                                            {item.collectMdocSdoc
                                                                ? "Awaiting MD & SDoC" :
                                                                item.isPCHM ?
                                                                    "PCHM"
                                                                    : item.ihmPresence
                                                                        ? "Yes"
                                                                        : "No"}
                                                        </span>
                                                    </span> */}
                                                    {/* {editPOView ?
                                                        <div class="btn-group">
                                                            <button class="btn btn-secondary btn-xs btn-conf-edit" data-confirmation="cancel" id={`popover${index}`}>
                                                                <i class="glyphicon glyphicon-remove"></i> Edit
                                                            </button>
                                                            <Popover placement="auto" trigger="legacy"
                                                                isOpen={this.state[`popover${index}`]}
                                                                target={`popover${index}`}
                                                                toggle={() => this.toggle(`popover${index}`, item)}>
                                                                <PopoverHeader>Edit</PopoverHeader>
                                                                <PopoverBody>
                                                                    <span><strong>IHM Presense</strong></span><br></br>
                                                                    <div className="row">
                                                                        <div className="col-4 my-1">
                                                                            <input type="radio" name="IHMYes" checked={this.state.IHMYes} onChange={e => this.handleRadioButtonChange(e)} />
                                                                            <span className="ml-1">Yes</span>
                                                                        </div>
                                                                        <div className="col-4 my-1">
                                                                            <input type="radio" name="IHMNo" checked={this.state.IHMNo} onChange={e => this.handleRadioButtonChange(e)} />
                                                                            <span className="ml-1">No</span>
                                                                        </div>
                                                                        <div className="col-4 my-1">
                                                                            <input type="radio" name="notApplicable" checked={this.state.PoConfirmation.notApplicable} onChange={e => this.handleRadioButtonChange(e)} />
                                                                            <span className="ml-1">NA</span>
                                                                        </div>
                                                                        <div className="col-12 my-1">
                                                                            <input type="radio" name="collectMdocSdoc" checked={this.state.PoConfirmation.collectMdocSdoc} onChange={e => this.handleRadioButtonChange(e)} />
                                                                            <span className="ml-1">Collect MD & SDoc</span>
                                                                        </div>
                                                                        <div className="col-12 my-1">
                                                                            <input type="checkbox" name="addKeyWords" checked={this.state.PoConfirmation.addKeyWords} onChange={e => this.checkBoxClick(e)} />
                                                                            <span className="ml-1"><strong>Add keywords</strong></span>
                                                                        </div>
                                                                        {this.state.PoConfirmation.addKeyWords ?
                                                                            <div className="col-12 my-1">
                                                                                <input type="text" name="keywords" value={this.state.keywords} className="form-control" style={{ height: "33px" }} onChange={e => this.handleInputChange(e)}></input>
                                                                            </div>
                                                                            : null}
                                                                        <div className="col-12 mt-1" style={{ textAlign: "right" }}>
                                                                            <div className="btn-group">
                                                                                <Button className="btn btn-primary btn-xs" size="sm" onClick={() => this.togglesubmit(`popover${index}`, item)}>Submit</Button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </PopoverBody>
                                                            </Popover>
                                                            <a class="btn btn-success btn-xs btn-conf-edit ml-1" data-confirmation="confirm" onClick={() => this.ConfirmPO(item)}>
                                                                <i class="glyphicon glyphicon-ok"></i> Confirm
                                                            </a>
                                                        </div> : null} */}
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>SDoC : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.sdocAttachmentName}
                                                        </span>
                                                        {item.sdocAttachmentName ? (
                                                            <span>
                                                                <i
                                                                    class="fa fa-download click ml-1"
                                                                    onClick={() =>
                                                                        this.downloadAttachment(
                                                                            item.sdocAttachmentName,
                                                                            item.sdocAttachmentGuid
                                                                        )
                                                                    }
                                                                ></i>
                                                                <i
                                                                    class="fa fa-trash-o click ml-1"
                                                                    onClick={() => this.deleteSAttachment(item)}
                                                                ></i>
                                                            </span>
                                                        ) : null}
                                                    </span>
                                                </div>
                                                <div className="col-md-2 py-1">
                                                    <span>
                                                        <strong>MD : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.mdocAttachmentName}
                                                        </span>
                                                        {item.mdocAttachmentName ? (
                                                            <span>
                                                                <i
                                                                    class="fa fa-download click ml-1"
                                                                    onClick={() =>
                                                                        this.downloadAttachment(
                                                                            item.mdocAttachmentName,
                                                                            item.mdocAttachmentGuid
                                                                        )
                                                                    }
                                                                ></i>
                                                                <i
                                                                    class="fa fa-trash-o click ml-1"
                                                                    onClick={() => this.deleteMAttachment(item)}
                                                                ></i>
                                                            </span>
                                                        ) : null}
                                                    </span>
                                                </div>
                                                {this.state.showEditPo !== "Read" &&
                                                    this.state.showEditPo !== "shippendingtask" && (
                                                        <div className="col-md-5 py-1">
                                                            {/* {options.map((option , i) => (
                                                        <>
                                                            <input
                                                                id={option.value + i}
                                                                key={i}
                                                                type="radio"
                                                                className="ml-1"
                                                                name="dynamic-radio"
                                                                value={item.radioButton}
                                                                checked
                                                                onChange={this.handleRadioChange}
                                                            />
                                                           <span className="ml-1">{option.value}</span>
                                                        </>
                                                    ))} */}
                                                            <span>
                                                                <strong>IHM Presense : </strong>
                                                            </span>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name={"IHMYes" + index}
                                                                id={"IHMYes" + index}
                                                                checked={item.radioButton == "Yes"}
                                                                onChange={(e) =>
                                                                    this.handleRadioButtonChange(
                                                                        e,
                                                                        "Yes",
                                                                        item.poLineItemId
                                                                    )
                                                                }
                                                            />
                                                            <span className="ml-1">Yes</span>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name={"IHMNo" + index}
                                                                id={"IHMYes" + index}
                                                                checked={item.radioButton == "No"}
                                                                onChange={(e) =>
                                                                    this.handleRadioButtonChange(
                                                                        e,
                                                                        "No",
                                                                        item.poLineItemId
                                                                    )
                                                                }
                                                            />
                                                            <span className="ml-1">No</span>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name={"notApplicable" + index}
                                                                id={"IHMYes" + index}
                                                                checked={item.radioButton == "NA"}
                                                                onChange={(e) =>
                                                                    this.handleRadioButtonChange(
                                                                        e,
                                                                        "NA",
                                                                        item.poLineItemId
                                                                    )
                                                                }
                                                            />
                                                            <span className="ml-1">NA</span>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name={"collectMdocSdoc" + index}
                                                                id={"IHMYes" + index}
                                                                checked={item.radioButton == "CL"}
                                                                onChange={(e) =>
                                                                    this.handleRadioButtonChange(
                                                                        e,
                                                                        "CL",
                                                                        item.poLineItemId
                                                                    )
                                                                }
                                                            />
                                                            <span className="ml-1">Collect MD & SDoC</span>
                                                        </div>
                                                    )}
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>Item Description : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">
                                                            {item.itemDescription}
                                                        </span>
                                                    </span>
                                                </div>
                                                {(item.make && item.model) &&
                                                    <>
                                                        <div className="col-md-2 py-1">
                                                            <strong>Make : </strong>
                                                            <i aria-hidden="true"></i>{" "}
                                                            <span className="italicFont">{item.make ?? ""}</span>
                                                        </div>
                                                        <div className="col-md-3 py-1">
                                                            <strong>Model : </strong>
                                                            <i aria-hidden="true"></i>{" "}
                                                            <span className="italicFont">{item.model ?? ""}</span>
                                                        </div>
                                                    </>
                                                }
                                                {item.make && !item.model &&
                                                    <div className="col-md-5 py-1">
                                                        <strong>Make : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">{item.make ?? ""}</span>
                                                    </div>
                                                }
                                                {item.model && !item.make &&
                                                    <div className="col-md-5 py-1">
                                                        <strong>Model : </strong>
                                                        <i aria-hidden="true"></i>{" "}
                                                        <span className="italicFont">{item.model ?? ""}</span>
                                                    </div>
                                                }
                                                {!item.make && !item.model &&
                                                    <div className="col-md-5 py-1">
                                                        <span>
                                                            <strong>Comments : </strong>
                                                            <i aria-hidden="true"></i>{" "}
                                                            <span className="italicFont">{item.comments}</span>
                                                        </span>
                                                    </div>
                                                }
                                                {/* <div className="col-md-1"></div> */}
                                                {this.state.showEditPo !== "Read" &&
                                                    this.state.showEditPo !== "shippendingtask" && (
                                                        <div className="col-md-3 py-1">
                                                            <span>
                                                                <strong>Add keywords </strong>
                                                            </span>
                                                            <input
                                                                type="text"
                                                                name="keyword"
                                                                value={item.keyword}
                                                                className="form-control mt-1"
                                                                style={{ height: "33px" }}
                                                                onChange={(e) =>
                                                                    this.handleInputChange(e, index)
                                                                }
                                                            ></input>
                                                        </div>
                                                    )}
                                                {(item.make || item.model) &&
                                                    <div className="col-md-12 py-1">
                                                        <span>
                                                            <strong>Comments : </strong>
                                                            <i aria-hidden="true"></i>{" "}
                                                            <span className="italicFont">{item.comments}</span>
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })
        ) : this.state.isLoaded ? (
            <div
                className="card"
                style={{ overflow: "hidden", position: "relative" }}
            >
                <div class="container">
                    <h6 className="resource-list-title no-item-card">No Items</h6>
                </div>
            </div>
        ) : null;
    }
    downloadAttachment = (FileName, Guid) => {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(FileName, Guid));
    };

    ShowMaterialDeclaration = (item) => {
        const { dispatch, history } = this.props;
        if (item === "") {
            dispatch({ type: "isInPoValidation", data: true });
        } else {
            dispatch({ type: "isInPoValidation", data: false });
        }
        history.push(
            `/Home/MDCollect/${item.poLineItemId ? item.poLineItemId : 0}`
        );
        dispatch({ type: "POLineItem", data: item });
        dispatch({ type: "AttachmentUploadMDocSuccess", data: null });
        dispatch({ type: "AttachmentUploadSDocSuccess", data: null });
    };

    deleteMAttachment = (item) => {
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipid, poid, type } = params;
        confirmAlert({
            message: "Are you sure want to delete ?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        if (type === undefined) {
                            history.location.pathname == `/Home/POViewEdit/${shipid}/${poid}`
                                ? dispatch(deleteMDocument(item, poid, this.state.taskType))
                                : dispatch(deleteMDocument(item, poid));
                        } else {
                            dispatch(deleteMDocument(item, poid, type));
                        }

                        this.state.LineItem = [];
                    },
                },
                {
                    label: "No",
                    onClick: () => { },
                },
            ],
        });
    };

    deleteSAttachment = (item) => {
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipid, poid, type } = params;
        confirmAlert({
            message: "Are you sure want to delete ?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        if (type === undefined) {
                            history.location.pathname == `/Home/POViewEdit/${shipid}/${poid}`
                                ? dispatch(deleteSDocument(item, poid, this.state.taskType))
                                : dispatch(deleteSDocument(item, poid));
                        } else {
                            dispatch(deleteSDocument(item, poid, type));
                        }

                        this.state.LineItem = [];
                    },
                },
                {
                    label: "No",
                    onClick: () => { },
                },
            ],
        });
    };
}

function mapStateToProps(state) {
    return {
        //BY BALU MOORTHI
        PODetail: state.POViewReducer.PODetail,
        POLineItems: state.POViewReducer.POLineItems,
        noPoLineItems: state.POViewReducer.noPoLineItems,
        editPOView: state.SidePanReducer.EditPOView || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(POViewHMV);
